import { swiperCreateNew } from "./swiper-settings";
import { initTextAnimations } from "assets/animations";

const hasPrevSiblingSection = (section) => {
	return (
		section.previousElementSibling &&
		section.previousElementSibling.tagName.toLowerCase() === "section"
	);
};

const goNextHandler = (section) => {
	const thisGoNextBtn = section.querySelector(".go-next-btn");
	thisGoNextBtn?.addEventListener("click", () => {
		const goToElem =
			section.querySelector(".hero__content--bot-content") ??
			section.nextElementSibling;
		if (goToElem)
			window.customScrollbarInstance?.scrollbarInstance?.scrollIntoView(
				goToElem,
			);
	});
};

const initSwiper = (section) => swiperCreateNew(section.id);

const initParallax = (section) => {
	const thisParallaxBgWrapper = section.querySelector(".hero__bg-wrapper");
	const thisParallaxBg = section.querySelector(".parallax-bg");

	if (!thisParallaxBg) return false;

	if (hasPrevSiblingSection(section)) {
		window.customScrollbarInstance?.parallaxController?.createElement({
			el: thisParallaxBg,
			props: {
				parentElem: thisParallaxBgWrapper,
				translateY: [-100, 100],
			},
		});

		const tl = window.customScrollbarInstance?.gsap?.timeline({
			scrollTrigger: {
				trigger: thisParallaxBg,
				start: "top top",
				end: "bottom top",
				scrub: true,
			},
		});

		tl.to(thisParallaxBg, {
			opacity: 0.3,
		});
	} else {
		const tl = window.customScrollbarInstance?.gsap?.timeline({
			ease: "none",
			scrollTrigger: {
				trigger: thisParallaxBgWrapper,
				start: "top top",
				end: "bottom top",
				scrub: true,
			},
		});

		tl.fromTo(
			thisParallaxBg,
			{
				opacity: 1,
				yPercent: 0,
			},
			{
				opacity: 0.3,
				yPercent: 50,
			},
		);
	}
};

const initSectionAnimation = (section) => {
	const thisContentWrapper = section.querySelector(".hero__animation-wrapper");
	if (!thisContentWrapper) return false;

	window.customScrollbarInstance?.gsap?.fromTo(
		thisContentWrapper,
		{
			yPercent: 100,
			rotateX: 75,
			scale: 1.5,
			opacity: 0,
			skewY: 7.5,
			transformOrigin: "0% 100%",
		},
		{
			yPercent: 0,
			rotateX: 0,
			scale: 1,
			opacity: 1,
			skewY: 0,
			duration: 1.5,
			ease: "power2.inOut",
			onComplete: () => {
				initParallaxAndAnimations(section);
			},
		},
	);
};

const initImageAnimation = (section) => {
	const thisContentImage = section.querySelector(
		".hero__content--top-content__image",
	);
	if (!thisContentImage) return false;

	if (!thisContentImage.classList.contains("animated")) {
		const parentElem = thisContentImage.closest(".hero__content--top-content");

		let containsSvg = false;
		for (let i = 0; i < thisContentImage.childNodes.length; i++) {
			const element = thisContentImage.childNodes[i];
			if (!element) break;
			if (element.tagName && element.tagName.toLowerCase() === "svg") {
				containsSvg = true;
				break;
			}
		}

		const elemToAnim = containsSvg
			? thisContentImage.querySelectorAll("svg path")
			: thisContentImage;

		window.customScrollbarInstance?.gsap?.to(elemToAnim, {
			y: "0",
			opacity: 1,
			duration: 1,
			stagger: 0.1,
			ease: "power2.inOut",
			delay: 0.5,
			scrollTrigger: {
				trigger: parentElem,
				start: "top center",
			},
			onComplete: (a, b) => {
				thisContentImage.classList.add("animated");
			},
		});
	}

	const tl = window.customScrollbarInstance?.gsap?.timeline({
		scrollTrigger: {
			trigger: thisContentImage,
			start: "top top",
			end: "bottom top",
			scrub: true,
		},
	});

	tl.to(thisContentImage, {
		opacity: 0,
	});
};

const initParallaxAndAnimations = (section) => {
	initParallax(section);
	const animatedBlocks = section.querySelectorAll(".animated-block");
	initTextAnimations({ blocks: animatedBlocks });
	initImageAnimation(section);
};

const initBlock = () => {
	const allHeroSections = document.querySelectorAll(
		".wp-block-theme-blocks-hero",
	);

	allHeroSections?.forEach((section) => {
		const thisSectionBg = section.querySelector(".hero__bg-wrapper");
		const thisSwiper = thisSectionBg?.querySelector(".swiper");

		goNextHandler(section);
		if (thisSwiper) initSwiper(section);

		if (hasPrevSiblingSection(section) || !thisSectionBg) {
			initParallaxAndAnimations(section);
		} else {
			initSectionAnimation(section);
		}
	});
};

window.addEventListener("load", () => {
	// console.log("HERO VIEW LOAD");

	initBlock();

	window.addEventListener(
		"change-page",
		() => {
			// console.log("HERO VIEW CHANGE PAGE");
			initBlock();
		},
		true,
	);
});
